import React from "react";

const Loader = () => {
  return (

    <div>
      <div id="global-loader">
        <img
          src="https://cdn.adgebra.net/Adgebra-Loader/Loader_Two.png"
          style={{
            position: "absolute",
            position: "absolute",
            top: "0",
            bottom: "0",
            margin: "auto",
          }}
          className="loader-img"
          alt="Loading.."
        />
      </div>
    </div>
  );
};

export default Loader;
